import { Outlet, Route } from "react-router-dom"
import { pagesUrl } from "../core/appConstants"
import { RseeDocumentContextProvider } from "../core/context/beem-pilot/rsee/RseeDocumentContext"
import { LotContextProvider } from "../core/context/lot-context"
import { RseeImportSummaryPage } from "../pages/projects/project/beem-pilot/RseeSummaryPage/RseeImportSummaryPage"
import { RseeUploadPage } from "../pages/projects/project/beem-pilot/RseeUploadPage/RseeUploadPage"
import { ExternalDocumentDashboard } from "../pages/projects/project/beem-pilot/external-dashboard/external-document-dashboard"
import { RseeDocumentDashboardPage } from "../pages/projects/project/tabs/BimPilotTab/components/RseeDocumentDashboardPage/RseeDocumentDashboardPage"

export const RseeRoutes = (
  <Route
    element={
      <LotContextProvider>
        <Outlet />
      </LotContextProvider>
    }>
    <Route
      element={
        <RseeDocumentContextProvider>
          <Outlet />
        </RseeDocumentContextProvider>
      }>
      <Route path={pagesUrl.BEEM_PILOT_UPLOAD_PAGE} element={<RseeUploadPage />} />
      <Route path={pagesUrl.BEEM_PILOT_DOCUMENT_SUMMARY_IMPORT} element={<RseeImportSummaryPage />} />
      <Route path={pagesUrl.BEEM_PILOT_DOCUMENT_DASHBOARD} element={<RseeDocumentDashboardPage />} />
    </Route>
    <Route path={pagesUrl.BEEM_PILOT_DASHBOARD_EXTERNAL} element={<ExternalDocumentDashboard />} />
  </Route>
)
